/**
 * Utility functions for handling brochure URLs and downloads
 */

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://raise-backend-254054690264.asia-south1.run.app' 
  : 'http://localhost:4000';

/**
 * Get the full URL for a brochure file
 * @param brochureUrl - The relative brochure URL from the database
 * @returns The full URL for the brochure
 */
export const getBrochureUrl = (brochureUrl: string): string => {
  if (!brochureUrl) return '';
  
  // If it's already a full URL (Cloud Storage or API), return as is
  if (brochureUrl.startsWith('http')) {
    return brochureUrl;
  }
  
  // If it starts with /uploads, prepend the API base URL (legacy local files)
  if (brochureUrl.startsWith('/uploads')) {
    return `${API_BASE_URL}${brochureUrl}`;
  }
  
  // If it starts with /tours or /gallery, it's a Cloud Storage path
  if (brochureUrl.startsWith('/tours') || brochureUrl.startsWith('/gallery')) {
    return `https://storage.googleapis.com/raise-uploads-storage${brochureUrl}`;
  }
  
  // If it's just a filename, prepend the uploads path (legacy)
  return `${API_BASE_URL}/uploads/${brochureUrl}`;
};

/**
 * Get the embedded URL for a brochure (for iframe display)
 * @param brochureUrl - The relative brochure URL from the database
 * @returns The full URL for embedding the brochure
 */
export const getBrochureEmbedUrl = (brochureUrl: string): string => {
  const fullUrl = getBrochureUrl(brochureUrl);
  if (!fullUrl) return '';
  
  // Add embedded parameter to help with PDF display
  return `${fullUrl}#embedded=true`;
};

/**
 * Get the download URL for a brochure
 * @param brochureUrl - The relative brochure URL from the database
 * @returns The full URL for downloading the brochure
 */
export const getBrochureDownloadUrl = (brochureUrl: string): string => {
  return getBrochureUrl(brochureUrl);
};

